// Test this by running the code snippet below and then
// use the "Offline" checkbox in DevTools Network panel

import store from '../store'

const ConnectionService = {
    _server_url: null,

    init(server_url) {
        console.log('init connection services')
        this._server_url = server_url;
        this.handleConnection(true);
    },

    handleConnection(boot) {
        if (navigator.onLine) {
             this.isReachable(this._server_url).then(function (online) {
                if (online) {
                    // handle online status
                    store.commit('internet', true)
                    console.log('online');
                } else {
                    store.commit('internet', false)
                    console.log('no connectivity');
                }
                if(boot) window.boot();
            })
        } else {
            // handle offline status
            store.commit('internet', false)
            console.log('offline');
            if(boot) window.boot();
        }
    },
    isReachable(url) {
        /**
         * Note: fetch() still "succeeds" for 404s on subdirectories,
         * which is ok when only testing for domain reachability.
         *
         * Example:
         *   https://google.com/noexist does not throw
         *   https://noexist.com/noexist does throw
         */

        console.log('is_reachable');
        return fetch(url, {method: 'HEAD', mode: 'no-cors'})
            .then(function (resp) {
                return resp && (resp.ok || resp.type === 'opaque');
            })
            .catch(function (err) {
                console.warn('[conn test failure]:', err);
            });
    }

}


export default ConnectionService


